import { render, staticRenderFns } from "./EditTransactions.vue?vue&type=template&id=04848e8c&scoped=true"
import script from "./EditTransactions.vue?vue&type=script&lang=js"
export * from "./EditTransactions.vue?vue&type=script&lang=js"
import style0 from "./EditTransactions.vue?vue&type=style&index=0&id=04848e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04848e8c",
  null
  
)

export default component.exports